import { geoArea, type LL } from '$lib/geo';
import { calc } from '$lib/solar';

let active = $state(false);
let verts = $state<LL[]>([]);

const area = $derived(Math.round(geoArea(verts)));
const kwp = $derived(calc(area).kwp);

export const draw = {
  get active() {
    return active;
  },
  get verts() {
    return verts;
  },
  get area() {
    return area;
  },
  get kwp() {
    return kwp;
  },
  start() {
    verts = [];
    active = true;
  },
  cancel() {
    verts = [];
    active = false;
  },
  clear() {
    verts = [];
  },
  addVert(ll: LL) {
    verts = [...verts, { lat: ll.lat, lng: ll.lng }];
  },
  removeVert(i: number) {
    verts = verts.filter((_, idx) => idx !== i);
  },
  undo() {
    verts = verts.slice(0, -1);
  },
  done() {
    active = false;
  },
};
